/**
 * A supplementary scan layered onto a model version's primary scan, plus the transform that
 * positions it relative to the primary. The transform is specific to the scan + version
 * combination and is stored on the model version, so the original scan record is never modified.
 *
 * The transform shape mirrors the API's TransformViewModel (position / rotation / scale).
 */
export function identityTransform() {
    return {
        position: { x: 0, y: 0, z: 0 },
        rotation: { isEuler: false, x: 0, y: 0, z: 0, order: "XYZ" },
        scale: { x: 1, y: 1, z: 1 },
    };
}

export default class ScanAssociation {
    scanId = null;
    transform = null;
    trimRadius = 0;

    constructor(scanId, transform = null, trimRadius = 0) {
        this.scanId = scanId;
        this.transform = transform ?? identityTransform();
        this.trimRadius = trimRadius;
    }
}
